import $ from "jquery";
export function modalAsFancybox() {
    const fancyboxes = $(".modal-fancybox, .fancybox");
    if (!fancyboxes.length) {
        return;
    }

    fancyboxes.on("click", (e) => {
        e.preventDefault();

        const $this = $(e.currentTarget);
        const target = $this.attr("href");

        if (target.indexOf("#") == 0) {
            $(target).modal("show");
        } else {
            if ($("#pnlModalPopup").length) {
                changeImage(target);
            } else {
                $("body").append(renderImg(target));
            }

            $("#pnlModalPopup").modal("show");

            $("#pnlModalPopup")
                .find("btn-close")
                .on("click", () => {
                    $("#pnlModalPopup").remove();
                });
        }
    });

    function renderImg(url: string) {
        return `<div id="pnlModalPopup" class="modal modal-fancybox fade" tabindex="-1" role="dialog" aria-hidden="true" data-index="-1">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content w-auto">      
                    <button type="button" class="btn-close" data-dismiss="modal">Zavřít</button>        
                    <div class="modal-body p-0">
                        <img id="imgModalPopup" src="${url}" alt="modal img">              
                    </div>               
                </div>
            </div>
        </div>`;
    }

    function changeImage(url: string) {
        if ($("#imgModalPopup").attr("src") != url) $("#imgModalPopup").attr("src", url);
    }
}
